import React from 'react';

import { ForcedAlignment } from '../popout/popout-helpers';
import styles from './basic-list-item.css';
import ListItem from './list-item';

interface BasicListItemProps extends ForcedAlignment {
  /** Text to display */
  header: string;
  /** Adds additional classes to the component. */
  className?: string;
  /** Contents of the flyout menu */
  flyoutMenu?: React.ReactElement<any>;
  /** Provides a data-testid */
  'data-testid'?: string;
}

export const BasicListItem = (props: BasicListItemProps) => {
  const { header, className, xAlign, yAlign, ...rest } = props;

  return (
    <ListItem className={className} {...rest} xAlign={xAlign} yAlign={yAlign}>
      <div className={styles.contentWrapper}>
        <div className={styles.title}>{header}</div>
      </div>
    </ListItem>
  );
};

export default BasicListItem;
